export function renderStatsTemplate(data, { html, __, _n, sprintf }) {
  // This is a plugin-shipped template, so its strings use the plugin text domain.
  // (Theme templates should pass their OWN domain instead, e.g. 'my-theme'.)
  const D = 'tangible-searchsync';
  const count =
    data.nbHits === 0
      ? __( 'no results', D )
      : sprintf( _n( '%d result', '%d results', data.nbHits, D ), data.nbHits );

  return html`<span>${count}</span>`;
}
